export function connect(schema: string): WebSocket {
  return new WebSocket(schema);
}
